import React, { useRef } from "react";
import "./ExploreSlider.css";

const ExploreSlider = ({ data }) => {
  const scrollRef = useRef();

  const scroll = (dir) => {
    scrollRef.current.scrollBy({
      left: dir === "left" ? -300 : 300,
      behavior: "smooth",
    });
  };

  return (
    <div className="slider-wrapper">
      
      <button className="scroll-btn left" onClick={() => scroll("left")}>
        ❮
      </button>

      <div className="slider" ref={scrollRef}>
        {data.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.image} alt={item.title} />
            <div className="card-body">
              <h4>{item.title}</h4>
              <p>{item.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      <button className="scroll-btn right" onClick={() => scroll("right")}>
        ❯
      </button>

    </div>
  );
};

export default ExploreSlider;